<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <v-row class="text-left search-bar">
      <v-col class="col-9 col-sm-8 py-5 px-4">
        <div v-if="this.addNewData != 0">
          <v-icon class="pl-6" size="14">mdi-checkbox-blank-circle</v-icon>
          <span class="px-1 pt14">繳費狀態：</span>
          <span class="px-1 pt14">{{(datasets.paymentStatus=='1') ? '已繳費': (datasets.paymentStatus=='2') ? '未繳費': ''}}</span>
        </div>
      </v-col>
      
      <v-col class="py-3 text-right pr-10 col-3 col-md-4">
        <!-- APP -->
        <div v-if="addNewData != 0 && datasets.deliveryStatus == 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="appBtn" style="display: none">
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
              <v-btn icon v-bind="attrs" v-on="on" class="webBtn" style="width:160px; border-radius:8px; color:#FFFFFF">
                <span class="px-2 menuAppBtn">功能選單</span>
                <v-icon style="color:#FFF">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list style="width: 200px;cursor: pointer">
              <v-list-item @click="$refs.ShowConfirm.open(0,'取消申請','提醒您，若您已付款，取消申請您須支付行政處理費新台幣250元及匯款手續費，若您已付款並且申請後請主動來信至service@cerps.org.tw，將有專人提供給您退款申請書，謝謝您。', true)">
                <v-list-item-title>
                  <span>取消申請</span>
                </v-list-item-title>
              </v-list-item>
              <!-- <v-list-item v-if="addNewData != 0 && datasets.receiptPrintCount > 0"
                @click="datasets.receiptPrintCount = datasets.receiptPrintCount-1, setDataset()">
                <v-list-item-title>
                  <span>下載收據</span><span style="font-size:7px">(下載次數{{datasets.receiptPrintCount}}/2)</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="addNewData != 0 && datasets.receiptPrintCount <= 0" style="background:#ddd"
                @click="$refs.ShowMsg.open(3)">
                <v-list-item-title>
                  <span>下載收據</span><span style="font-size:7px">(下載次數{{datasets.receiptPrintCount}}/2)</span>
                </v-list-item-title>
              </v-list-item> -->
            </v-list>
          </v-menu>
        </div>
        <!-- <v-btn v-if="addNewData != 0 && datasets.receiptPrintCount > 0" class="btn" outlined style="width:220px" @click="datasets.receiptPrintCount = datasets.receiptPrintCount-1, setDataset()">
          <v-icon class="pr-2" size="16">mdi-cloud-print-outline</v-icon>
          <span>下載收據</span><span style="font-size:7px">(下載次數{{datasets.receiptPrintCount}}/2)</span>
        </v-btn>
        <v-btn v-if="addNewData != 0 && datasets.receiptPrintCount <= 0" class="btn" outlined style="width:220px; background:#aaa" @click="$refs.ShowMsg.open(3)">
          <v-icon class="pr-2" size="16">mdi-cloud-print-outline</v-icon>
          <span>下載收據</span><span style="font-size:7px">(下載次數{{datasets.receiptPrintCount}}/2)</span>
        </v-btn> -->
      </v-col>
    </v-row>
    <div id="router" :style="viewStyle">
        <div id="box" class="pa-5" style="margin-top:3%; overflow-x:auto">
          <v-row>
            <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
            <h4 class="DarkBlue pt-1">申請項目說明</h4>
          </v-row>
          <v-row class="pb-5" style="overflow-x: auto">
            <div style="min-width:780px">
              <v-img :src="images.instruction" contain height="160" alt="申請項目說明圖示"></v-img>
            </div>
          </v-row>
        </div>
      <div id="box" class="pa-5 mt-3">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">申請場次及證書繳費方式確認</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>報考場次</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.examNo"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>申請項目</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <!-- <v-select class="text_field" dense background-color="white" outlined placeholder="選擇申請項目" :items="applyItemList" item-text="title" item-value="valuev" v-model="datasets.applyItem"></v-select> -->
                <v-select class="text_field" dense outlined :placeholder="!(addNewData == 0) ? '' : '選擇申請項目'"
                :class="{'v-select_readonly': !(addNewData == 0)}" :readonly="!(addNewData == 0)" :background-color="!(addNewData == 0)?'#F4F8F9':'#FFF'"
                :items="applyItemList" item-text="title" item-value="valuev" v-model="datasets.applyItem">
                  <template v-if="!(addNewData == 0)" v-slot:append>
                    <v-icon></v-icon>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>申請費用</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.applyFee"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0 py-1">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>繳費方式</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0 pt-2 pl-6">
                <v-radio-group class="ma-0 pa-0" dense :readonly="!(addNewData == 0)" v-model="datasets.paymentMethod">
                  <v-row>
                    <v-radio class="pr-2" value="0" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">信用卡繳款</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="1" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">ATM、銀行郵局臨櫃繳款</span>
                      </template>
                    </v-radio>
                    <!-- <v-radio class="pr-2" value="2" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">LINE Pay</span>
                      </template>
                    </v-radio>
                    <v-radio class="pr-2" value="3" color="#215DA7">
                      <template v-slot:label>
                        <span class="pt14" style="color:#000000">銀聯卡</span>
                      </template>
                    </v-radio> -->
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>收據抬頭</div>
              </v-col>
              <v-col class="col-5 col-md-4 py-0">
                <v-text-field class="text_field" dense outlined placeholder="請輸入收據抬頭" maxlength="50" v-model="datasets.receiptTitle"
                :readonly="!(addNewData == 0) || (datasets.sameName==true)" :background-color="!(addNewData == 0) || (datasets.sameName == true)?'#F4F8F9':'#FFF'">
                </v-text-field>
              </v-col>
              <v-col class="col-5 col-md-4 py-0 pt-1">
                <v-checkbox class="ma-0 pa-0" :readonly="!(addNewData == 0)" v-model="datasets.sameName">
                  <template v-slot:label>
                    <span class="pt14" style="color:#000000">與中文姓名同</span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>繳費期限</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.paymentDeadline"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14">備註內容</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <textarea class="text_field pa-4" rows="6" outlined required dense style="width:100%; border: 1px solid #999999" 
                :style = "[{'background' : !(addNewData == 0) ? '#F4F8F9' : '#FFF'},]" 
                :readonly="!(addNewData == 0)" v-model="datasets.note"></textarea>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <div id="box" class="pa-5 mt-3">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#215DA7">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">寄送資訊確認</h4>
        </v-row>
        <v-row class="mx-2">
          <v-col class="pa-0 col-12 col-md-6">
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4"></v-col>
              <v-col class="col-10 col-md-8">
                <v-checkbox class="ma-0 pa-0 pt14" color="#81C0E2" label="同報名資訊" :readonly="!(addNewData == 0)" v-model="datasets.sameName1"></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>收信人</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense outlined placeholder="請輸入姓名" 
                :readonly="!(addNewData == 0) || (datasets.sameName1==true)" :background-color="!(addNewData == 0) || datasets.sameName1?'#F4F8F9':'#FFF'" v-model="datasets.receiver"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2 col-md-4">
                <div class="text-right pt-2 pt14"><span class="start">*</span>聯絡手機</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense outlined placeholder="請輸入手機" 
                :readonly="!(addNewData == 0) || (datasets.sameName1==true)" :background-color="!(addNewData == 0) || datasets.sameName1?'#F4F8F9':'#FFF'" v-model="datasets.ctel"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pa-0 col-12 col-md-6">
            <v-row v-if="data.citizenShip=='1'" class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14">郵遞區號</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined placeholder="自動顯示" v-model="datasets.zipCode"></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-0">
              <v-col class="px-0 col-2">
                <div class="text-right pt-2 pt14"><span class="start">*</span>寄送地址</div>
              </v-col>
              <v-col class="col-10 col-md-8 py-0">
                <v-row v-if="data.citizenShip=='1'" class="px-3">
                  <v-select v-if="addNewData == 0" class="text_field mr-2" dense outlined style="width:48%" placeholder="請選擇縣市"
                  :readonly="(datasets.sameName1==true)" :background-color="(datasets.sameName1==true)?'#F4F8F9':'#FFF'"
                  :items="countryList" item-text="country" item-value="country" v-model="datasets.country"></v-select>
                  <v-text-field v-if="addNewData != 0 && datasets.country" class="text_field mr-2" dense outlined readonly :background-color="'#F4F8F9'" style="width:48%" v-model="datasets.country"></v-text-field>

                  <v-select v-if="addNewData == 0" class="text_field" dense outlined style="width:48%" placeholder="請選擇行政區"
                  :readonly="(datasets.sameName1==true)" :background-color="(datasets.sameName1==true)?'#F4F8F9':'#FFF'"
                  :items="areaList" item-text="area" item-value="area" v-model="datasets.area">
                  </v-select>
                  <v-text-field v-if="addNewData != 0 && datasets.area" class="text_field" dense outlined readonly :background-color="'#F4F8F9'" style="width:48%" v-model="datasets.area"></v-text-field>
                </v-row>
                <v-row class="ma-0">
                  <v-text-field class="text_field" dense outlined placeholder="請輸入詳細地址" 
                  :readonly="!(addNewData == 0) || datasets.sameName1 == true" :background-color="!(addNewData == 0)|| datasets.sameName1 == true?'#F4F8F9':'#FFF'" v-model="datasets.address"></v-text-field>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>

      <v-row class="mx-0 pa-0 my-6" justify="center">
        <v-btn class="ma-1 loginBack col-9 col-sm-4 col-md-4 col-lg-3" outlined style="height:40px; background:#FFFFFF; border-radius:8px; border: 1px solid #81c0e2"
        @click="redirectPath('/registerInformation')">
          <span style="color:#81c0e2">返回</span>
        </v-btn>
        <v-btn v-if="addNewData==0" class="ma-1 loginBtn col-9 col-sm-4 col-md-4 col-lg-3" outlined style="width:22%; height:40px; background:#81c0e2; border-radius:8px; border:none" @click="newDataset()">
          <span style="color:#FFFFFF">確認申請</span>
        </v-btn>
      </v-row>
    </div>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
    <ShowConfirm ref="ShowConfirm" :onSave="deleteCertificateDelivery"/>
  </div>
</template>

<script>
import ShowMsg from '@/dialogs/ShowMsg'
import ShowConfirm from '@/dialogs/ShowConfirm'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  name: 'ApplyCertificatePersonal',
  components: {ShowMsg, ShowConfirm, Loading},
  mounted(){
    this.addNewData = (JSON.parse(this.$Global.decrypt(this.$route.query.deliverId)) == -1) ? 0 : 1
    this.data = JSON.parse(this.$Global.decrypt(this.$route.query.data))
    Promise.all([
      new Promise((resolve)=>{resolve(this.$Global.getCountryList().then(res=>{ this.countryList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getApplyItemList().then(res=>{ this.applyItemList = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getClassItemClass3List(this.data.class1, this.data.class2).then(res=>{ this.classItemClass3List = res }))}),
      new Promise((resolve)=>{resolve(this.$Global.getMemberTypeList().then(res=>{ this.memberTypeList = res }))}),
      new Promise((resolve)=>{resolve(this.getDataset())}),
    ]).then(()=>{
      this.applyItemListA()
      setTimeout(() => { this.initDone = true; }, 100); //delay 0.1s
    })
  },
  data:() => ({
    images:{
      instruction: require('@/assets/image/instruction.png')
    },
    keyword:'',
    datasets: [],
    viewStyle:{},
    showInfo:0,
    addNewData:0, //0-新增 1-修改
    initDone: false,
    isLoading: false,

    data: {},
    countryList: [],
    applyItemList: [],
    areaList: [],
    classItemClass3List: [],
    requiredField:['examNo','applyItem','applyFee','paymentMethod','receiptTitle','paymentDeadline','receiver','ctel','address'],
    requiredField2:['zipCode','country','area'],
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "datasets.sameName1":function(){
      if(this.initDone){
        this.datasets.receiver = this.data.name
        this.datasets.ctel = this.data.ctel
        this.datasets.zipCode = this.data.zipCode
        this.datasets.country = this.data.country
        this.datasets.area = this.data.area
        this.datasets.address = this.data.address
      }
    },
    "datasets.country":function(){
      this.$Global.getAreaListByCountryList(this.datasets.country).then(res=>{ this.areaList = res })
    },
    "datasets.area":function(){
      if(this.initDone){
        this.datasets.zipCode = this.$Global.getZipCode(this.areaList, this.datasets.area, this.datasets.zipCode)
      }
    },
    "datasets.sameName":function(){
      if(this.initDone){
        if(this.datasets.sameName == true){
          this.datasets.receiptTitle = this.datasets.name
        }
      }
    },
    "datasets.applyItem":function(){
      if(this.initDone){
        this.datasets.applyFee = this.$Global.getApplyFee(this.classItemClass3List, this.data.class3, this.datasets.applyItem)
      }
    }
  },
  computed: {},
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-128 + 'px'}
    },
    redirectPath(path){
      this.$router.push({path: path, query: {
        id: this.$route.query.id,
        tab: this.$route.query.tab,
      }})
    },
    newDataset() {
      //未開通繳費方式
      if(this.datasets.paymentMethod=='2' || this.datasets.paymentMethod=='3'){
        this.$refs.ShowMsg.open(0,'繳費方式尚未開啟','請選擇「信用卡繳款」或「ATM、銀行郵局臨櫃繳款」繳費方式，「LINE Pay」及「銀聯卡」繳費方式尚未開啟，感謝您的配合 !')
        this.datasets.paymentMethod=''
        return
      }
      //
      if(!this.$Global.checkForm(this.datasets,this.requiredField)){
        this.$refs.ShowMsg.open(1)
        return
      }
      if(this.data.citizenShip == '1'){
        if(!this.$Global.checkForm(this.datasets,this.requiredField2)){
          this.$refs.ShowMsg.open(1)
          return
        }
      }
      this.isLoading = true
      var allData = this.$Global.copy(this.datasets)
      allData = this.$Global.jsonConcat(allData,{'createId':sessionStorage.getItem('cerpsMemberIdCard')})
      allData = this.$Global.jsonConcat(allData,{'applicantName':sessionStorage.getItem('cerpsMemberName')})
      allData = this.$Global.jsonConcat(allData,{'applicantIdCard':sessionStorage.getItem('cerpsMemberIdCard')})
      allData = this.$Global.jsonConcat(allData,{'citizenShip':this.data.citizenShip})
      allData = this.$Global.jsonConcat(allData,{'paymentStatus':'2'})
      allData = this.$Global.jsonConcat(allData,{'deliveryStatus':'0'})
      var self = this
      var request = {
        method: 'POST',
        url: '/certificateDelivery',
        data: this.Qs.stringify(allData)
      }
      this.$http(request).then(function(response) {
        self.$refs.ShowMsg.open(0,'申請成功','已申請成功，請在指定時間內完成繳費。',true,true)
        self.isLoading = false
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Acp-7956')
        self.isLoading = false
      })
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/certificateDelivery/' + ((self.addNewData == 0) ? '2' : JSON.parse(this.$Global.decrypt(self.$route.query.deliverId))),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
        console.log(response)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Acp-7957')
      }).finally(()=>{
          if(self.addNewData == 0){
            self.datasets.examName = self.data.examName
            self.datasets.examNo = self.data.examNo
            self.datasets.examScore = self.data.examScore
            self.datasets.idCard = self.data.idCard
            self.datasets.name = self.data.name
            self.datasets.sameName1 = (self.data.sameRcvCert == 'true') ? true : false
            self.datasets.receiver = self.data.name
            self.datasets.ctel = self.data.ctel
            self.datasets.email = self.data.email
            self.datasets.zipCode = self.data.zipCode
            self.datasets.country = self.data.country
            self.datasets.area = self.data.area
            self.datasets.address = self.data.address
            self.datasets.certificateNo = self.data.certNo
            self.datasets.applyItem = null
            self.datasets.applyFee = null
            self.$Global.getCertificatePaymentDeadline().then(res=>{ this.datasets.paymentDeadline = res })
          }
        })
    },
    applyItemListA(){
      let tmp = this.applyItemList
      this.applyItemList = []
      if((this.data.examPass == '通過') ? true : false){
        this.applyItemList = []
        this.applyItemList = tmp
        return
      }else{
        this.applyItemList.push(tmp[0])
        this.applyItemList.push(tmp[1])
      }
    },
    setDataset(){
      var self = this
      var request = {
        method: 'PUT',
        url: '/certificateDelivery',
        data: this.Qs.stringify(this.datasets)
      }
      this.$http(request).then(function(response) {
        // console.log(response)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Acp-7958')
      }).finally(()=>{
        self.getDataset()
      })
    },
    deleteCertificateDelivery(){
      var self = this
      var request = {
        method: 'PUT',
        url: '/certificateDeliveryStatusUpdate/' + self.$Global.decrypt(self.$route.query.deliverId),
        params: {},
      }
      this.$http(request).then(function(response) {
        self.$refs.ShowMsg.open(0,'已取消申請','您已取消該筆申請 !',true,true)
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Acp-7959')
      }).finally(()=>{
      })
    },
    onShowMsg(){
      this.redirectPath('/registerInformation')
    },
  }
}
</script>